var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"tabs",staticClass:"c-tab-container"},_vm._l((_vm.subject_list),function(item){return _c('div',{key:item.subjectId,staticClass:"c-tab",class:_vm.activeId==item.subjectId?'active':'',on:{"click":function($event){return _vm.changeSubject(item.subjectId)}}},[_vm._v(" "+_vm._s(item.subjectName)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }